// src/pages/admin/onboarding-control/components/AddStepModal.jsx

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const AddStepModal = ({
  isOpen,
  onClose,
  onAdd,
  existingIds,
  packageTiers = [],
}) => {
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    title: "",
    description: "",
    icon: "📌",
    color: "#4f46e5",
    tiers: [
      "starter",
      "lite",
      "growth",
      "pro",
      "enterprise",
      "premium",
      "business",
    ],
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.id.trim()) newErrors.id = "ID is required";
    if (existingIds.includes(formData.id)) newErrors.id = "ID already exists";
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.title.trim()) newErrors.title = "Header title is required";
    if (!formData.description.trim())
      newErrors.description = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      onAdd(formData);
      setFormData({
        id: "",
        name: "",
        title: "",
        description: "",
        icon: "📌",
        color: "#4f46e5",
        tiers: [
          "starter",
          "lite",
          "growth",
          "pro",
          "enterprise",
          "premium",
          "business",
        ],
      });
      setErrors({});
    }
  };

  const toggleTier = (tierId) => {
    const currentTiers = formData.tiers || [];
    if (currentTiers.includes(tierId)) {
      setFormData({
        ...formData,
        tiers: currentTiers.filter((t) => t !== tierId),
      });
    } else {
      setFormData({ ...formData, tiers: [...currentTiers, tierId] });
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <motion.div
            className="modal-content"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>Add Onboarding Wizard Step</h2>
              <button className="modal-close" onClick={onClose}>
                ✕
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Step ID Key</label>
                <input
                  type="text"
                  value={formData.id}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      id: e.target.value.toLowerCase(),
                    })
                  }
                  placeholder="e.g. shipping"
                />
                {errors.id && <span className="error-text">{errors.id}</span>}
              </div>

              <div className="form-group">
                <label>Step Dot Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  placeholder="e.g. Shipping"
                />
                {errors.name && (
                  <span className="error-text">{errors.name}</span>
                )}
              </div>

              <div className="form-group">
                <label>Header Title</label>
                <input
                  type="text"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  placeholder="e.g. Shipping & Delivery Setup"
                />
                {errors.title && (
                  <span className="error-text">{errors.title}</span>
                )}
              </div>

              <div className="form-group">
                <label>Subtitle Description</label>
                <input
                  type="text"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  placeholder="e.g. Configure your default store shipping rates"
                />
                {errors.description && (
                  <span className="error-text">{errors.description}</span>
                )}
              </div>

              <div className="form-group">
                <label>Available for Tiers</label>
                <div className="tier-selector-modal">
                  {packageTiers.map((tier) => (
                    <label key={tier.id} className="tier-checkbox-modal">
                      <input
                        type="checkbox"
                        checked={(formData.tiers || []).includes(tier.id)}
                        onChange={() => toggleTier(tier.id)}
                      />
                      <span>{tier.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label>Step Icon & Color</label>
                <div className="icon-color-picker">
                  <input
                    type="text"
                    value={formData.icon}
                    onChange={(e) =>
                      setFormData({ ...formData, icon: e.target.value })
                    }
                    className="icon-input"
                  />
                  <input
                    type="color"
                    value={formData.color}
                    onChange={(e) =>
                      setFormData({ ...formData, color: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={onClose}>
                Cancel
              </button>
              <button className="btn-add-step" onClick={handleSubmit}>
                Add Step
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default AddStepModal;
